// Home's MCP cards (docs/features/mcp-sign-in.md): under a Mac's name, one card per MCP server on it that needs you —
// "linear needs you to sign in" with Sign in on the Mac, "sentry can't connect" with Retry and Restart Workspace.
// The press goes to the Mac (core/mcp.js › pressMcp); the sign-in opens in the Mac's browser. The card goes by itself
// once the Mac says the server is connected.
//
// One seam: `mcpCards(m, esc, icon)` → the cards' HTML for Home's state of a Mac ({key, link, mcp, mcpBusy, mcpErrors}).
// A button is `data-act="mcp:<mac key>|<action>|<alert id>"`.
import { title, detail, actions, clip } from '../../core/mcp.js'

export function mcpCards(m, esc, icon) {
  if (m.link !== 'online' || !m.mcp?.length) return ''
  return m.mcp.map((a) => {
    const signIn = a.status === 'needs_auth'
    const busy = m.mcpBusy?.has?.(a.id)
    const error = m.mcpErrors?.get?.(a.id)
    const buttons = actions(a, false).map((b) =>
      `<button class="go" data-act="mcp:${esc(m.key)}|${esc(b.id)}|${esc(a.id)}"${busy ? ' disabled' : ''}>${esc(busy ? 'Asking the Mac…' : b.label)}</button>`).join('')
    return `<div class="ht-notice ${signIn ? 'warn' : 'bad'}" data-mcp="${esc(a.id)}"><img src="${icon(signIn ? 'person.badge.key' : 'exclamationmark.triangle', signIn ? 'var(--c-orange)' : 'var(--c-red)')}">` +
      `<div class="texts"><div class="t">${esc(title(a))}</div><div class="c">${esc(detail(a))}</div>${error ? `<div class="c">${esc(clip(error))}</div>` : ''}</div>${buttons}</div>`
  }).join('')
}
